import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { CommonMethodService } from "../../common/commonMethod.service";
import { ResidentService } from '../../services/resident.service';

@Component({
  selector: 'app-current-vehicle',
  templateUrl: './currentVehicle.component.html',
  providers: [CommonMethodService]
})

export class CurrentVehicleComponent implements OnInit, OnDestroy {
  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  subscribe: Array<Subscription> = [];
  pageable: any;
  searchBy: string = '';
  loader: boolean = false;

  accountId: number;
  flatId: number;


  // Vehicle
  vehicleInfoList: Array<any> = [];

  checkOutDriverName: String;
  referenceNumber: String;
  tempObject: any;


  constructor(private toaster: ToastrService, private residentService: ResidentService, private activeRoute: ActivatedRoute,
    private route: Router, private commonMethod: CommonMethodService) { }

  ngOnInit() {
    this.accountId = (Number)(sessionStorage.getItem('accountId'));
    this.flatId = (Number)(sessionStorage.getItem('flatId'));
    this.pageable = {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0
    };
    this.activeRoute.queryParams.subscribe(
      params => {
        this.pageable.currentPage = params['page'] ? params['page'] : 1;
        this.fetchVehicleList();
      }
    );

  }

  fetchVehicleList(): void {
    this.loader = true;
    this.subscribe.push(this.residentService.getAllCommercialVehicleListByAccountId(this.pageable, this.accountId, this.searchBy, 'CHECK_IN').subscribe(
      data => {
        this.loader = false;
        const wrapper = JSON.parse(JSON.stringify(data));
        this.pageable.totalItems = wrapper.totalElements;
        this.vehicleInfoList = wrapper.content;
      }, error => {
        this.loader = false;
        this.commonMethod.returnErrorMessage(error);
      }));
  }

  CheckOutModal(object) {
    this.checkOutDriverName = null;
    this.referenceNumber = null;
    this.tempObject = object;
    this.primaryModal.show();
  }

  confirmCheckOut() {
    if (this.checkOutDriverName == null || this.checkOutDriverName == undefined) {
      this.toaster.error("Please enter Driver Name");
      return;
    }
    if (this.referenceNumber == null || this.referenceNumber == undefined) {
      this.toaster.error("Please enter reference number");
      return;
    }
    this.checkOut(this.tempObject);
  }

  checkOut(obj): void {
    let details: any = {};
    details.id = obj.id;
    details.accountId = this.accountId;
    details.type = 'CHECK_OUT';
    details.referenceNumber = this.referenceNumber;
    details.checkOutDriverName = this.checkOutDriverName;
    this.loader = true;
    this.subscribe.push(this.residentService.checkInCheckOutCommercialVehicle(details).subscribe(
      data => {
        this.loader = false;
        this.toaster.success('Vehicle successfully checked out.');
        this.primaryModal.hide();
        this.ngOnInit();
      }, error => {
        this.loader = false;
        this.commonMethod.returnErrorMessage(error);
      }));
  }

  search(event): void {
    if (event.currentTarget.value !== undefined || event.currentTarget.value !== '') {
      this.searchBy = event.currentTarget.value;
      this.ngOnInit();
    }
  }
  refreshPage(): void {
    this.ngOnInit();
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }

  pageChange(newPage: number) {
    this.route.navigate(['/home/vehicleManagement/currentVehicle'], { queryParams: { page: newPage } });
  }

  onPageSizeChange(size: number): void {
    this.pageable.itemsPerPage = size;
    this.pageable.currentPage = 1;
    this.fetchVehicleList();
  }
}
